// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1bove","title":"Info_title__1Hi_O","links":"Info_links__3MvAy","link":"Info_link__3GuKF","logo":"Info_logo__30Hdp"};